import axios from "axios";
import { notifBody } from "lib/createNotif";
import { getApiToken } from "lib/firebase";
import { alertError } from "lib/utils";

import { CurrentUser, NotifType } from "lib/type";

const subject = (type: NotifType) => {
  switch (type) {
    case "like":
      return "いいねされました。";
    case "comment":
      return "コメントされました。";
    case "follow":
      return "フォローされました。";
    case "announce":
      return "おしらせ";
    default:
      return "お知らせはありません。";
  }
};

const href = (type: NotifType, articleID: string, uid: string) => {
  switch (type) {
    case "like":
      return `/articles/${articleID}/`;
    case "comment":
      return `/articles/${articleID}/`;
    case "follow":
      return `/users/${uid}`;
    default:
      return "";
  }
};

const linkText = (type: NotifType) => {
  switch (type) {
    case "like":
      return "記事を確認する";
    case "comment":
      return "コメントを確認する";
    case "follow":
      return "フォローしてくれたユーザーを確認する";
    case "announce":
      return "おしらせ";
    default:
      return "お知らせはありません。";
  }
};

const html = (
  text: string,
  type: NotifType,
  authorUid: string,
  articleID: string,
  uid: string
) => `
  <img style="display:block; max-width: 160px;" src="${
    process.env.NEXT_PUBLIC_WEB_URL
  }/htmlmail_logo.png" alt="${process.env.NEXT_PUBLIC_SITE_NAME}">
  <br>
  <p style="fotn-size: 20px">${text}</p>
  <br>
  <a href="${process.env.NEXT_PUBLIC_WEB_URL}${href(
  type,
  articleID,
  uid
)}" style="color: #1089ec; font-weight: 700" target="_blank" rel="nofollow noreferrer noopener">
  ${linkText(type)} >
  </a>
  <br>
  <div style="border-top: 2px solid gray;"></div>
  <br>
  <p>
  メールの配信停止は、
  <a href="${
    process.env.NEXT_PUBLIC_WEB_URL
  }/users/${authorUid}/settings/" style="color: #1089ec;" target="_blank" rel="nofollow noreferrer noopener">
    「プロフィール設定」
  </a>
  から行なえます。
  </p>
  `;

export const sendNotifMail = async (
  author: CurrentUser,
  user: CurrentUser,
  type: NotifType,
  articleID = "",
  articleTitle = ""
) => {
  if (!author || !user || author.uid === user.uid) return;

  try {
    const apiToken = await getApiToken();
    const text = notifBody(type, user.name, articleTitle);
    const msg = {
      to: author.email,
      from: `${
        process.env.NEXT_PUBLIC_SITE_NAME
      }@${process.env.NEXT_PUBLIC_SITE_NAME?.toLocaleLowerCase()}.com`,
      subject: `${subject(type)} | ${process.env.NEXT_PUBLIC_SITE_NAME}`,
      text: text,
      html: html(text, type, author.uid, articleID, user.uid),
    };

    axios.post("/api/send-notif-email", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + apiToken,
      },
      body: msg,
    });
  } catch (err) {
    alertError(err);
  }
};
